document.addEventListener('DOMContentLoaded', function() {
  // Function to get URL parameters as an object
  function getUrlParams() {
    const params = {};
    window.location.search.substring(1).split("&").forEach(param => {
      const [key, value] = param.split("=");
      if (key) params[key] = decodeURIComponent(value);
    });
    return params;
  }

  // Function to update the URL while keeping other parameters
  function updateUrl(collection, params) {
    // Remove any existing collection parameter
    delete params.collection;
    const baseUrl = `/collections/${collection}`;
    const queryString = new URLSearchParams(params).toString();
    console.log(`Updating URL to: ${baseUrl}?${queryString}`);
    window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  }

  // Function to handle filter changes
  function handleFilterChange() {
    const filters = document.querySelectorAll('.facet-checkbox input[type="checkbox"]');
    const checkedFilters = Array.from(filters).filter(checkbox => checkbox.checked);
    const customCheckedFilters = checkedFilters.filter(checkbox => checkbox.name === 'collection');
    const params = getUrlParams();

    let collection = 'swu-star-wars-unlimited';
    if (customCheckedFilters.length === 1) {
      collection = customCheckedFilters[0].value;
    }

    console.log(`Checked custom filters: ${customCheckedFilters.length}, Redirecting to collection: ${collection}`);
    updateUrl(collection, params);
  }

  // Attach event listeners to the custom filter checkboxes
  const customFilters = ['Filter-ShadowsOfTheGalaxy', 'Filter-SparkOfRebellion']; // Add more filter IDs as needed
  customFilters.forEach(filterId => {
    const filterElement = document.getElementById(filterId);
    if (filterElement) {
      console.log(`Attaching change event to: ${filterId}`);
      filterElement.addEventListener('change', handleFilterChange);

      // Check if the current URL matches any of the collections and check the checkbox if it does
      const currentUrl = window.location.pathname;
      const selectedCollection = filterElement.value;
      if (currentUrl.includes(`/collections/${selectedCollection}`)) {
        filterElement.checked = true;
        console.log(`Checkbox ${filterId} is checked based on URL`);
      }
    } else {
      console.error(`Filter element not found: ${filterId}`);
    }
  });
});
